import { CourseAttributeSortColumns } from '@/jbi-shared/types/jtms.types';
import { CourseAttributeSortableHeaderOption } from './course-attribute.types';

// Sortable header option values specific to trainer accreditations table ONLY
export const courseAttributeSortableHeaders: CourseAttributeSortableHeaderOption[] = [
  {
    columnName: 'Attribute Label',
    sortColumn: CourseAttributeSortColumns.ATTRIBUTE_LABEL,
    sort: true
  },
  {
    columnName: 'Content Type',
    sortColumn: CourseAttributeSortColumns.CONTENT_TYPE,
    sort: true
  }
];
